// extracted by mini-css-extract-plugin
export default {"container":"Challenge_container__AEqqM","challenge":"Challenge_challenge__LOnMD"};